import { all, fork, put, takeLatest, call } from 'redux-saga/effects';
import {
    getWeatherImpactSummary,
    getWeatherImpactEventMix,
    getWeatherImpactCarrierPerformance,
    getWeatherImpactShipmentReport,
    getWeatherImpactWarehouseImpact,
    getWeatherImpactEventSummary,
    getWeatherImpactMap,
} from '../../helpers';
import {
    weatherImpactApiResponseSuccess,
    weatherImpactApiResponseError,
} from './actions';
import { WeatherImpactActionTypes } from './constants';

export function* getSummarySaga({ payload: { query } }) {
    try {
        const response = yield call(getWeatherImpactSummary, query);
        yield put(weatherImpactApiResponseSuccess(WeatherImpactActionTypes.GET_SUMMARY_REQUEST, response.data));
    } catch (error) {
        yield put(weatherImpactApiResponseError(WeatherImpactActionTypes.GET_SUMMARY_REQUEST, error));
    }
}

export function* getEventMixSaga({ payload: { query } }) {
    try {
        const response = yield call(getWeatherImpactEventMix, query);
        yield put(weatherImpactApiResponseSuccess(WeatherImpactActionTypes.GET_EVENT_MIX_REQUEST, response.data));
    } catch (error) {
        yield put(weatherImpactApiResponseError(WeatherImpactActionTypes.GET_EVENT_MIX_REQUEST, error));
    }
}

export function* getCarrierPerformanceSaga({ payload: { query } }) {
    try {
        const response = yield call(getWeatherImpactCarrierPerformance, query);
        yield put(weatherImpactApiResponseSuccess(WeatherImpactActionTypes.GET_CARRIER_PERFORMANCE_REQUEST, response.data));
    } catch (error) {
        yield put(weatherImpactApiResponseError(WeatherImpactActionTypes.GET_CARRIER_PERFORMANCE_REQUEST, error));
    }
}

export function* getShipmentReportSaga({ payload: { query } }) {
    try {
        const response = yield call(getWeatherImpactShipmentReport, query);
        yield put(weatherImpactApiResponseSuccess(WeatherImpactActionTypes.GET_SHIPMENT_REPORT_REQUEST, response.data));
    } catch (error) {
        yield put(weatherImpactApiResponseError(WeatherImpactActionTypes.GET_SHIPMENT_REPORT_REQUEST, error));
    }
}

export function* getWarehouseImpactSaga({ payload: { query } }) {
    try {
        const response = yield call(getWeatherImpactWarehouseImpact, query);
        yield put(weatherImpactApiResponseSuccess(WeatherImpactActionTypes.GET_WAREHOUSE_IMPACT_REQUEST, response.data));
    } catch (error) {
        yield put(weatherImpactApiResponseError(WeatherImpactActionTypes.GET_WAREHOUSE_IMPACT_REQUEST, error));
    }
}

export function* getEventSummarySaga({ payload: { query } }) {
    try {
        const response = yield call(getWeatherImpactEventSummary, query);
        yield put(weatherImpactApiResponseSuccess(WeatherImpactActionTypes.GET_EVENT_SUMMARY_REQUEST, response.data));
    } catch (error) {
        yield put(weatherImpactApiResponseError(WeatherImpactActionTypes.GET_EVENT_SUMMARY_REQUEST, error));
    }
}

export function* getMapSaga({ payload: { query } }) {
    try {
        const response = yield call(getWeatherImpactMap, query);
        yield put(weatherImpactApiResponseSuccess(WeatherImpactActionTypes.GET_MAP_REQUEST, response.data));
    } catch (error) {
        yield put(weatherImpactApiResponseError(WeatherImpactActionTypes.GET_MAP_REQUEST, error));
    }
}

function* weatherImpactSaga() {
    yield all([
        fork(function* watchGetSummarySaga(): any {
            yield takeLatest(WeatherImpactActionTypes.GET_SUMMARY_REQUEST, getSummarySaga);
        }),
        fork(function* watchGetEventMixSaga(): any {
            yield takeLatest(WeatherImpactActionTypes.GET_EVENT_MIX_REQUEST, getEventMixSaga);
        }),
        fork(function* watchGetCarrierPerformanceSaga(): any {
            yield takeLatest(WeatherImpactActionTypes.GET_CARRIER_PERFORMANCE_REQUEST, getCarrierPerformanceSaga);
        }),
        fork(function* watchGetShipmentReportSaga(): any {
            yield takeLatest(WeatherImpactActionTypes.GET_SHIPMENT_REPORT_REQUEST, getShipmentReportSaga);
        }),
        fork(function* watchGetWarehouseImpactSaga(): any {
            yield takeLatest(WeatherImpactActionTypes.GET_WAREHOUSE_IMPACT_REQUEST, getWarehouseImpactSaga);
        }),
        fork(function* watchGetEventSummarySaga(): any {
            yield takeLatest(WeatherImpactActionTypes.GET_EVENT_SUMMARY_REQUEST, getEventSummarySaga);
        }),
        fork(function* watchGetMapSaga(): any {
            yield takeLatest(WeatherImpactActionTypes.GET_MAP_REQUEST, getMapSaga);
        }),
    ]);
}

export default weatherImpactSaga;
